import { render } from "./StatsCaDerniersJours.vue?vue&type=template&id=79118e33&ts=true"
import script from "./StatsCaDerniersJours.vue?vue&type=script&lang=ts"
export * from "./StatsCaDerniersJours.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__